export default [{
        caption: 'Event group',
        width: 300,
        dataField: 'event_group_name',
        area: "row",
        isMeasure: false,
    },
    {
        dataField: "fromDate",
        dataType: "date",
        groupInterval: 'year'
        // groupInterval: 'Month',
        // area: "column"
    },
    {
        dataField: "fromDate",
        dataType: "date",
        groupInterval: 'month'
        // groupInterval: 'Month',
        // area: "column"
    },
    {
        dataField: "fromDate",
        dataType: "date",
        groupInterval: 'day'
        // groupInterval: 'Month',
        // area: "column"
    },
    {
        caption: 'Total sales',
        dataField: 'sales_total',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Total sales VAT',
        dataType: 'number',
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields',
        calculateCustomSummary: function(options) {
            if (options.summaryProcess === 'start') {
                options.totalSales = 0;
                options.totalAmount = 0;
                options.totalWithoutVAT = 0;
                options.totalWithVAT = 0;
            }
            if (options.summaryProcess === 'calculate') {
                // Calculate VAT rate from costs
                const costsWithoutVAT = options.value.costs_total || 0;
                const costsWithVAT = options.value.costs_total_vat || 0;
                
                // Calculate VAT rate
                let vatRate = 1;
                if (costsWithoutVAT > 0) {
                    vatRate = costsWithVAT / costsWithoutVAT;
                }
                
                // Apply VAT rate to sales
                const salesWithoutVAT = options.value.sales_total || 0;
                const salesWithVAT = salesWithoutVAT * vatRate;
                
                // Calculate sales unit VAT
                const amount = Number(options.value.Menge || 0);
                const salesUnitVAT = amount > 0 ? salesWithVAT / amount : 0;
                
                // Total sales VAT is sales unit VAT multiplied by amount
                options.totalSales += salesUnitVAT * amount;
            }
            if (options.summaryProcess === 'finalize') {
                options.totalValue = options.totalSales;
            }
        }
    },
    {
        caption: 'Total costs',
        dataField: 'costs_total',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Costs Unit',
        dataField: 'costs',
        dataType: 'number',
        summaryType: 'min',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Costs Unit VAT',
        dataField: 'costs_vat',
        dataType: 'number',
        summaryType: 'min',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Total costs VAT',
        dataField: 'costs_total_vat',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
    caption: 'VAT Rate (%)',
    dataType: 'number',
    summaryType: 'custom',
    format: {
        type: 'decimal',
        precision: 1,
    },
    isMeasure: true,
    displayFolder: 'Fields',
    calculateCustomSummary: function(options) {
        if (options.summaryProcess === 'start') {
            options.totalWithoutVAT = 0;
            options.totalWithVAT = 0;
        }
        if (options.summaryProcess === 'calculate') {
            options.totalWithoutVAT += options.value.costs_total || 0;
            options.totalWithVAT += options.value.costs_total_vat || 0;
        }
        if (options.summaryProcess === 'finalize') {
            // MwSt.-Satz berechnen
            if (options.totalWithoutVAT > 0) {
                const vatAmount = options.totalWithVAT - options.totalWithoutVAT;
                const vatRate = (vatAmount / options.totalWithoutVAT) * 100;
                options.totalValue = vatRate;
            } else {
                options.totalValue = 0;
            }
        }
    }
    },
    {
        caption: 'Amount',
        dataField: 'Menge',
        dataType: 'number',
        summaryType: 'sum',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Arrangement fee',
        dataField: 'arrangement_fee',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Commission',
        dataField: 'commission',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Contractual commission',
        dataField: 'contractualCommission',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        // area: 'data',
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Is Contractual',
        dataField: 'is_contractual',
        dataType: 'number',
        customizeText: function (cellInfo) {
            // Your code goes here
            if (cellInfo.value === 1) {
                return 'Contractual'
            } else {
                return 'Not contractual'
            } 
        }
    },
    {
        caption: 'Event Country',
        dataField: 'event_country',
        dataType: 'string',
        // customizeText: function (cellInfo) {
        //     // Your code goes here
        //     return `<img src="${cellInfo.value}">`
        // },
        onCellPrepared: function(element, info) {
            element.append(`<img src="${info.text}">`)
                   .css("color", "blue");
       }
    },
    {
        isMeasure: true,
        displayFolder: 'Fields',
        caption: "Guests",
        summaryType: 'custom',
        calculateCustomSummary: function(options){
            if (options.summaryProcess == 'start') {
                // Initializing "totalValue" here
                options.twoAndThreeDay = 0
            }
            if (options.summaryProcess == 'calculate') {
                // Modifying "totalValue" here
                if (options.value.FK_ArticleType === 1 || options.value.FK_ArticleType === 2) {
                    options.twoAndThreeDay += options.value.Menge
                }
            }
            if (options.summaryProcess == 'finalize') {
                // Assigning the final value to "totalValue" here
                options.totalValue = options.twoAndThreeDay
            }
       }
    },
    {
        isMeasure: true,
        displayFolder: 'Fields',
        caption: "Contractual costs",
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        calculateCustomSummary: function(options){
            if (options.summaryProcess == 'start') {
                // Initializing "totalValue" here
                options.contractualCosts = 0
            }
            if (options.summaryProcess == 'calculate') {
                // Modifying "totalValue" here
                if (options.value.is_contractual === 1) {
                    options.contractualCosts += options.value.costs_total
                }
            }
            if (options.summaryProcess == 'finalize') {
                // Assigning the final value to "totalValue" here
                options.totalValue = options.contractualCosts
            }
       }
    },
    {
        isMeasure: true,
        displayFolder: 'Fields',
        caption: "Non contractual costs",
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        calculateCustomSummary: function(options){
            if (options.summaryProcess == 'start') {
                // Initializing "totalValue" here
                options.nonContractualCosts = 0
            }
            if (options.summaryProcess == 'calculate') {
                // Modifying "totalValue" here
                if (options.value.is_contractual === 0) { 
                    options.nonContractualCosts += options.value.costs_total
                }
            }
            if (options.summaryProcess == 'finalize') {
                // Assigning the final value to "totalValue" here
                options.totalValue = options.nonContractualCosts
            }
       }
    },
    {
        caption: 'Com Unit',
        dataType: 'number',
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields',
        calculateCustomSummary: function(options) {
            if (options.summaryProcess === 'start') {
                options.totalCommission = 0;
                options.totalAmount = 0;
            }
            if (options.summaryProcess === 'calculate') {
                options.totalCommission += Number(options.value.commission || 0);
                options.totalAmount += Number(options.value.Menge || 0);
            }
            if (options.summaryProcess === 'finalize') {
                if (options.totalAmount > 0) {
                    const commissionPerUnit = options.totalCommission / options.totalAmount;
                    options.totalValue = commissionPerUnit;
                } else {
                    options.totalValue = 0;
                }
            }
        }
    },
    {
        caption: 'Com Contractual Unit',
        dataType: 'number',
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields',
        calculateCustomSummary: function(options) {
            if (options.summaryProcess === 'start') {
                options.totalCommission = 0;
                options.totalAmount = 0;
            }
            if (options.summaryProcess === 'calculate') {
                options.totalCommission += Number(options.value.contractualCommission || 0);
                options.totalAmount += Number(options.value.Menge || 0);
            }
            if (options.summaryProcess === 'finalize') {
                if (options.totalAmount > 0) {
                    const commissionPerUnit = options.totalCommission / options.totalAmount;
                    options.totalValue = commissionPerUnit;
                } else {
                    options.totalValue = 0;
                }
            }
        }
    },
    {
        caption: 'Sales Unit',
        dataType: 'number',
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields',
        calculateCustomSummary: function(options) {
            if (options.summaryProcess === 'start') {
                options.totalSales = 0;
                options.totalAmount = 0;
            }
            if (options.summaryProcess === 'calculate') {
                // Calculate sales without VAT
                const salesWithoutVAT = options.value.sales_total || 0;
                options.totalSales += Number(salesWithoutVAT);
                options.totalAmount += Number(options.value.Menge || 0);
            }
            if (options.summaryProcess === 'finalize') {
                if (options.totalAmount > 0) {
                    const salesPerUnit = options.totalSales / options.totalAmount;
                    options.totalValue = salesPerUnit;
                } else {
                    options.totalValue = 0;
                }
            }
        }
    },
    {
        caption: 'Sales Unit VAT',
        dataType: 'number',
        summaryType: 'custom',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields',
        calculateCustomSummary: function(options) {
            if (options.summaryProcess === 'start') {
                options.totalSales = 0;
                options.totalAmount = 0;
                options.totalWithoutVAT = 0;
                options.totalWithVAT = 0;
            }
            if (options.summaryProcess === 'calculate') {
                // Calculate VAT rate from costs
                const costsWithoutVAT = options.value.costs_total || 0;
                const costsWithVAT = options.value.costs_total_vat || 0;
                
                // Calculate VAT rate
                let vatRate = 1;
                if (costsWithoutVAT > 0) {
                    vatRate = costsWithVAT / costsWithoutVAT;
                }
                
                // Apply VAT rate to sales
                const salesWithoutVAT = options.value.sales_total || 0;
                const salesWithVAT = salesWithoutVAT * vatRate;
                options.totalSales += Number(salesWithVAT);
                options.totalAmount += Number(options.value.Menge || 0);
            }
            if (options.summaryProcess === 'finalize') {
                if (options.totalAmount > 0) {
                    const salesPerUnitWithVAT = options.totalSales / options.totalAmount;
                    options.totalValue = salesPerUnitWithVAT;
                } else {
                    options.totalValue = 0;
                }
            }
        }
    },
    {
        caption: 'Agency passthrough',
        dataField: 'agency_value',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields'
    },
    {
        caption: 'Arrangement fee gross',
        dataField: 'arrangement_fee_gross',
        dataType: 'number',
        summaryType: 'sum',
        format: {
            type: 'decimal',
            precision: 2,
        },
        isMeasure: true,
        displayFolder: 'Fields'
    }
]
